
/**
 * easy-ajax v 2
 * author: ABTanjir
 * author URI: https://abtanjir.com/
 * source: https://github.com/ABTanjir/easy-ajax/
*/

/**
 * Serialize A Form To JSON
 */
 (function ($) {
    $.fn.serializeFormJSON = function () {
		console.log('serializing...')
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery);

if ( typeof Object.create !== 'function' ) {
    Object.create = function( obj ) {
        function F() {}
        F.prototype = obj;
        return new F();
    };
}

(function($) {
    "use strict"
    var EasyAjax = {
        initLinkClick: function( options, elem ) {
            var self = this;
            self.elem = elem;
            self.options = $.extend( {}, $.fn.easyajax.options, options );
            var ajax_link_dotless = options.ajax_link.replace(/^\./, "");
            // on link click
            var csrf = $("meta[name=csrf-token]");
            $(document).on('click', options.ajax_link, function(e) {
                if(
                    (e.target.tagName.toLowerCase() === 'a' &&  $(e.target).hasClass(ajax_link_dotless)) ||
                    (e.currentTarget.tagName.toLowerCase() === 'a' &&  $(e.currentTarget).hasClass(ajax_link_dotless))
                ){
                    e.preventDefault();
                    self.$elem = $( this );
                    var method = self.$elem.attr('method');
                    if(self.$elem.data('confirm')){
                        let confirm_msg = self.$elem.data('text') || 'Click ok if you want to proceed';
                        self.sweetConfirm(self.$elem.data('confirm'), confirm_msg, function(confirm){

                            if(confirm){
                                self.sendRequest(method, csrf.attr("content"));
                            }
                        })
                    }else if(self.$elem.data('ask')){
                        //if need confirmation
                        let inputName = $(this).data('input-name') || 'input'; // dynamic key name

                        let confirm_msg = self.$elem.data('text') || 'Type a note and click ok to proceed';
                        self.sweetAsk($(this).data('ask'), confirm_msg, function(confirm){
                            if(confirm.value){
                                let payload = {
                                    [inputName]: confirm.value
                                };
                                self.sendRequest(method, csrf.attr("content"), payload);
                            }
                        })
                    }else if(self.$elem.data('ask-numeric')){
                        //if need confirmation
                        let inputName = $(this).data('input-name') || 'input'; // dynamic key name
                        let confirm_msg = self.$elem.data('text') || 'Type a note and click ok to proceed';
                        self.sweetAskNumeric($(this).data('ask-numeric'), confirm_msg, function(confirm){
                            if(confirm.value){
                                let payload = {
                                    [inputName]: confirm.value
                                };
                                self.sendRequest(method, csrf.attr("content"), payload);
                            }
                        })
                    }else{
                        self.sendRequest(method, csrf.attr("content"));
                    }
                }
            });
        },

        init: function( options, elem ) {
            self = this;
            self.elem = elem;
            self.$elem = $( elem );
            self.$elem.content = self.$elem.find(":submit").html();
            self.options = $.extend( {}, $.fn.easyajax.options, options );
            // self.toolbar = $('<div class="tool-container gradient" />').addClass('tool-'+self.options.position);
            self.setTrigger(self.options, self.elem);
            self.options.csrf = $("meta[name=csrf-token]").attr("content");
        },

        setTrigger: function(options, elem) {
            var self = this;

            // console.log('ssubmit listener added.', options.ajax_form)
            // self.$elem.on('submit', function(e) {
            $(document).on('submit', options.ajax_form, function(e) {
                var _form =  this
                e.preventDefault();
                // console.log('clicked ajax submit form')
                // $(this).remove();
                var isValidated = null
                if($(this).hasClass('needs-validation')){
                    if (_form.checkValidity() === false) {
                        e.preventDefault();
                        e.stopPropagation();
                        isValidated = false;
                    }else{
                        isValidated = true;
                    }

                    if(!$(this).hasClass('was-validated')){
                        self.realTimeValidate(_form);
                    }
                    _form.classList.add('was-validated')
                }
                var has_form_error = false;
                $(this).find('.form-control').each(function(i, obj) {
                    if($(obj).parent().find('.invalid-feedback').length){
                        $(obj).parent().find('.invalid-feedback').text(obj.validationMessage);
                    }else{
                        $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback">'+obj.validationMessage+'</em>');
                    }

                    // support tab error show
                    var err_tab = $(obj).closest('.tab-pane');
                    var err_tab_id = "#"+err_tab.attr('id');
                    if(obj.checkValidity() == false){
                        if(err_tab.length){
                            err_tab.addClass("pane_has_error");
                            $("[href='"+err_tab_id+"']").addClass('tab_has_error');
                        }
                        return false;
                    }else{
                        if(err_tab.length){
                            err_tab.removeClass("pane_has_error");
                            $("[href='"+err_tab_id+"']").removeClass('tab_has_error');
                        }
                    }
                });

                if(isValidated === false) return false;

                if($(this).data('confirm')){
                    let confirm_msg = self.$elem.data('text') || 'Click ok if you want to proceed';
                    self.sweetConfirm( $(_form).data('confirm'), confirm_msg, function(confirm){
                        if(confirm){
                            self.postRequest(e, _form);
                        }
                    })
                }else if(self.$elem.data('ask')){
                    //if need confirmation
                    self.sweetAsk($(this).data('ask'), 'Type a note and click ok to proceed', function(confirm){
                        if(confirm.value){
                            self.postRequest(e, _form);
                        }
                    })
                }else{
                    self.postRequest(e, _form);
                }
            });


        },

        realTimeValidate: function(form){
            var self = this;
            // on input changes validate inputs
            $(form).on('input', function(e) {
                e.preventDefault();

                $(this).closest('form').find('.form-control').each(function(i, obj) {
                    if(e.target.validationMessage.length == 0){
                        $(e.target).removeClass('is-invalid');
                        return true;
                    }
                    if($(obj).parent().find('.invalid-feedback').length){
                        $(obj).parent().find('.invalid-feedback').text(obj.validationMessage);
                    }else{
                        $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback">'+obj.validationMessage+'</em>');
                    }
                });
            });
        },

        // actions
        render_to: function(data){
            var self = this;
            $(data.render_to).html(data.html).trigger('changed');
            self.options.after_render(self.$elem, data)
        },

        notification: function(data, form = null){
            var self = this;
            // console.log('show notification')
            $(this).remove();
            if(data.status != 'success'){
                self.$elem.find(":submit").prop('disabled', false);
            }else{
                if(form){
                    if (typeof $(form).closest('.modal').modal === 'function') {
                        $(form).closest('.modal').modal("hide");
                    }
                }
            }

            if(typeof self.options.notification === 'function'){

                self.options.notification(data)
            }else{
                if((typeof toastr !== 'undefined')){
                    toastr.options = {
                        "debug": false,
                        "newestOnTop": true,
                        "progressBar": true,
                        "positionClass": "toast-bottom-right",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    };
                    toastr[data.status](data.message);
                }
            }
        },
        rerender: function(action){
            var self = this;
            console.log('rerender', action);
            var current_url = window.location.href;
            console.log('rerender', current_url);

            // Show loading indicator
            var $target = $(action.rerender);
            if($target.length <= 0 || action.rerender == true){
                $target = $('.app-main');
            }
            $target.block({
                message: $(
                    `<div class="loader mx-auto">
                        <div class="line-scale-pulse-out">
                            <div class="bg-success"></div>
                            <div class="bg-success"></div>
                            <div class="bg-success"></div>
                            <div class="bg-success"></div>
                            <div class="bg-success"></div>
                        </div>
                    </div>`
                ),
                css: {
                    border: 'none',
                    backgroundColor: 'transparent',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 0,
                    margin: 0,
                    width: 'auto', // <- override the default 30%
                },
                centerY: false,
            })
            $.ajax({
                url: current_url,
                type: 'GET',
                success: function(data) {
                    var parsedHtml = $.parseHTML(data);
                    if ($(parsedHtml).find(action.rerender).length <= 0){
                        action.rerender = '.app-main';
                    }
                    $(action.rerender).html($(parsedHtml).find(action.rerender).html()).trigger('change');
                }
            });
        },
        remove: function(data){
            var self = this;
            self.$elem.closest(data.remove).css({"background":'#b2bec3', 'transition': 'linear background .3s'}).delay(300).queue(function(){
                $(this).remove();
            });
        },

        // ---------------------------.actions.-------------------------------- //

        validate: function() {
            //show form validation
            $('.form-control').each(function(i, obj) {
                if($(obj).parent().find('.invalid-feedback').length){
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage);
                }else{
                    $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback">'+obj.validationMessage+'</em>');
                }
            });
        },

        isJson: function(str){
            return typeof str == 'object';
        },

        sweetConfirm: function(title, message, callback) {
            // console.log(typeof Swal)
            if((typeof Swal !== 'undefined')){
                Swal.fire({
                    title: title,
                    text: message,
                    icon: 'warning',
                    showCancelButton: true
                }).then((confirmed) => {
                    callback(confirmed && confirmed.value == true);
                });
            }else{
                if(confirm(title)){
                    callback(true)
                }
            }
        },
        sweetAsk: function(title, message, callback) {
            Swal.fire({
                title: title,
                text: message,
                icon: 'warning',
                input: 'text',
                showCancelButton: true
            }).then((confirmed) => {
                callback(confirmed);
            });
        },

        sweetAskNumeric: function(title, message, callback) {
            Swal.fire({
                title: title,
                text: message,
                icon: 'warning',
                input: 'text',
                inputAttributes: {
                    inputmode: 'decimal',
                    placeholder: 'Enter a numaric value'
                },
                preConfirm: (value) => {
                    return new Promise((resolve) => {
                        if (!/^\d*\.?\d+$/.test(value)) {
                            Swal.showValidationMessage('Please enter a valid number');
                        } else {
                            resolve(value);
                        }
                    });
                },

                didOpen: () => {
                    const inputEl = Swal.getInput();
                    inputEl.addEventListener('input', () => {
                        const value = inputEl.value;
                        const isValid = /^\d*\.?\d+$/.test(value);
                        if (isValid) {
                            Swal.resetValidationMessage(); // Clear the error
                            Swal.getConfirmButton().disabled = false; // Re-enable button
                        } else {
                            Swal.getConfirmButton().disabled = true; // Keep it disabled
                        }
                    });
                },
                willOpen: () => {
                    Swal.getConfirmButton().disabled = true; // Start disabled until valid input
                },

                showCancelButton: true
            }).then((confirmed) => {
                callback(confirmed);
            });
        },

        sendRequest: function(method = 'GET', csrf = null, extra_data = null){
            var self = this;
            var url = self.$elem.attr('href');
            var data = null;

            if(csrf) {
                data = {_token:csrf};
            }
            if(extra_data){
                data = {...extra_data, ...data};
            }

            var __submit_content = self.$elem.html()
            self.$elem.html(beautify.loading())
            // # TODO  NEED DEBUGGING
            $.ajax({
                url: url,
                type: method,
                data: data,
                success: function(data) {
                    self.options.after_ajax(self.$elem, data);

                    if(!self.isJson(data)){
                        data = JSON.parse(data)
                    }


                    if(data.message){
                        self.notification(data);
                    }

                    if(data.render_to){
                        self.render_to(data);
                    }
                    if(data.rerender){
                        self.rerender(data);
                    }

                    if(data.remove){
                        self.remove(data);
                    }

                    if(data.empty){
                        $(data.empty).html('');
                    }

                    if(data.reset){
                        $(self).trigger('reset');
                    }

                    if(data.redirect){
                        window.location.href = data.redirect
                    }
                    // response [refresh] value can be 'datatable', id_selector, microseconds
                    if(data.refresh){
                        // console.log('EASY AJAX: REFRESH GET')
                        if(data.refresh === true){
                            console.log("refresh page...");
                            window.location.reload(1);
                        }else if(data.refresh === 'datatable'){
                            console.log("refresh datatable class...");
                            $('.dataTable').DataTable().ajax.reload();
                        }else if(typeof data.refresh == 'number'){
                            // if an id is selected then refrest that with datatable
                            console.log("refresh page after "+data.refresh+" ms");
                            setTimeout(function(){
                                window.location.reload(1);
                            }, data.refresh);
                        }else if($(data.refresh).length > 0){
                            console.log("refresh "+data.refresh);
                            $(data.refresh).DataTable().ajax.reload();
                        }else{
                            window.location.reload(1);
                        }
                    }

                    self.$elem.html(__submit_content)
                    self.$elem.prop('disabled', false);
                },
                error: function(err){
                    if(err.responseJSON){
                        var message = (err.responseJSON.message) ? err.responseJSON.message : "Oops! Something went wrong.";
                    }else{
                        var message = (err.message) ? err.message : "Oops! Something went wrong.";
                    }
                    var data = {
                        status: "error",
                        message: message
                    };
                    self.notification(data);
                    self.$elem.html(__submit_content)
                    self.$elem.prop('disabled', false);
                }
            });
        },

        postRequest: function(e, form){
            var self = this;
            var btn_submit = $(form).find(":submit");
            var __submit_content = btn_submit.html()
            btn_submit.prop('disabled', true);

            //enable submit button after certain second
            if(self.options.autoEnable){
                setTimeout(function(){
                    btn_submit.html(__submit_content)
                    btn_submit.prop('disabled', false);
                }, self.options.autoEnable);
            }

            var action = $(form).attr('action');
            var method = $(form).attr('method');
            var formData = new FormData(form);

            self.options.before_ajax(form);

            if(self.options.csrf){
                formData.append('_token', self.options.csrf);
            }
            $.ajax({
                type: method,
                url: action,
                processData: false,
                contentType: false,
                data: formData, // serializes the form's elements.
                success: function(data){

                    // enable submit button instantly if success
                    btn_submit.html(__submit_content)
                    btn_submit.prop('disabled', false);

                    self.options.after_ajax(self.$elem, data);

                    if(!self.isJson(data)){
                        data = JSON.parse(data)
                    }

                    if(data.message){
                        self.notification(data, form);
                    }

                    if(data.render_to){
                        self.render_to(data);
                    }

                    if(data.rerender){
                        self.rerender(data);
                    }

                    if(data.remove){
                        self.remove(data);
                    }

                    if(data.empty){
                        $(data.empty).html('');
                    }

                    if(data.reset){
                        // console.log("form reset")
                        $(form).removeClass('was-validated')
                        $(form).find('.form-control').val("")
                        $(".select2").val("");
                        $(".select2").trigger("change");
                        $(".select2-tag").val("");
                        $(".select2-tag").trigger("change");

                    }

                    if(data.event || data.trigger){
                        if(data.event){
                            $(document).trigger(data.event);
                        }else if(data.trigger){
                            $(document).trigger(data.trigger);
                        }
                    }

                    let form_id = $(form).attr('id');
                    $('#'+form_id).trigger('ea.success')

                    // response [refresh] value can be 'datatable', id_selector, microseconds
                    if(data.refresh){
                        // console.log('EASY AJAX: REFRESH POST')
                        if(data.refresh === 'datatable'){
                            if($(form).closest('table').hasClass('dataTable')){
                                $(form).closest('table').remove()
                                $(form).closest('table').DataTable().dataTable.reload();
                            }
                        }else if(typeof data.refresh == 'number'){
                            // if an id is selected then refrest that with datatable
                            setTimeout(function(){
                                window.location.reload(1);
                            }, data.refresh);

                        }else if($(data.refresh).length > 0){
                            $(data.refresh).DataTable().ajax.reload();
                        }
                    }


                },
                error: function(xhr){
                    self.options.error_ajax(form, xhr);

                    //enable submit form
                    btn_submit.html(__submit_content)
                    btn_submit.prop('disabled', false);

                    if(typeof self.options.notification === 'function'){
                        self.options.notification(xhr, 'error')
                    }
                }
            });
        }

    };

    $.fn.easyajax = function( options ) {
        var easyAjaxObj = Object.create( EasyAjax );
        easyAjaxObj.initLinkClick( options, this );
        easyAjaxObj.init( options, this );
    };

    $.fn.easyajax.options = {
        autoEnable: 5000,
        notification: null,
        ajax_link: '.ajax',
        ajax_form: '.ajax',
        csrf: null,
        after_render: function(el, data){},
        before_ajax: function(el, data){},
        after_ajax: function(el, data){},
        error_ajax: function(el, data){},
    };

}) (jQuery);
